import { setCookie } from '../utils/cookie';

export default class MobileNav extends HTMLDivElement {

    connectedCallback() {

        this.addEventListener("shown.bs.offcanvas", this.setFocus);
        

    }

    disconnectedCallback() {
        this.removeEventListener("shown.bs.offcanvas", this.setFocus);
    }

    setFocus() {
        if (this.dataset.focusTarget !== null) {

            this.querySelector(this.dataset.focusTarget)?.focus();

        }
    }

}

customElements.define('mobile-nav', MobileNav, { extends: 'div' });